var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 22.9975C12.8086 15.5002 12.8885 15.0002 8.30859 9.00024C6.78196 7.00024 5.80859 6.00024 2.80833 2.00293",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67578 22.9975C7.86719 15.5002 7.78729 15.0002 12.3672 9.00024C13.8938 7.00024 14.8672 6.00024 17.8674 2.00293",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.e6e7703c6d14ad104b3118fb5e009ee8.svg";
export { ForwardRef as ReactComponent };